import { useTheme } from '../hooks/useTheme';
import { Theme } from '../state/theme';
import { PushDrawerContainer, PushDrawerContainerProps } from './PushDrawer';

export function PushDrawerContainerWrapper(props: Omit<PushDrawerContainerProps, 'isDarkTheme'>) {
  const { theme } = useTheme();

  return <PushDrawerContainer {...props} isDarkTheme={theme === Theme.DARK} />;
}
